import React, { useContext } from 'react';
import { View, Text, StyleSheet, FlatList } from 'react-native';
import Card from '../../components/Card';
import { MainColors } from '../../constants/Colors';
import { cardShadow } from '../../constants/Shadows';
import FontSizes from '../../constants/FontSizes';
import LoadingIndicator from '../../components/ActivityIndicator';
import { FontAwesome5 } from '@expo/vector-icons';
import TwoLineMessage from '../../components/TwoLineMessage';
import { OrganizationContext } from '../../context/OrganizationProvider';
import useInfiniteScroll from '../../utils/useInfiniteScroll'
import useFetch from '../../utils/useFetch';

const ResultsScreen = ({ navigation }) => {
    const { get } = useFetch()
    const { organizationId } = useContext(OrganizationContext);
    const pageSize = 50

    const getResults = async (pageNumber) => await get(`/api/ballots?filterStatus=completed&organizationId=${organizationId}&page=${pageNumber}&count=${pageSize}`)

    const [resultsList, onScrollPage, onRefresh, isRefreshing] = useInfiniteScroll(getResults)

    return (
        <View style={styles.screen}>
            <LoadingIndicator isLoading={isRefreshing}>
                {(resultsList && resultsList.length > 0 ? (
                    <FlatList
                        contentContainerStyle={{ padding: 20 }}
                        style={{ width: '100%' }}
                        data={resultsList}
                        keyExtractor={(item) => item.id.toString()}
                        ListFooterComponentStyle={{ marginTop: 10 }}
                        onEndReached={onScrollPage}
                        onEndReachedThreshold={5}
                        onRefresh={onRefresh}
                        refreshing={isRefreshing}
                        renderItem={({ item }) => (
                            <Card style={styles.resultsCard} disabled={false}
                                onPress={() => {
                                    navigation.navigate('BallotResultsRundown', {
                                        ballotId: item.id
                                    })
                                }}>
                                <View style={styles.cardHeaderContainer}>
                                    <Text style={styles.ballotTitle}>{item.title}</Text>
                                </View>
                                {item.ballotItems.map(ballotItem => (
                                    <View key={ballotItem.ballotItemId} style={styles.cardContentContainer}>
                                        <Text style={styles.ballotItemTitle}>{ballotItem.ballotItemTitle}</Text>

                                        {ballotItem.ballotItemStatus === 'Winner' ? (
                                            <View style={styles.ballotItemResultsContainer}>
                                                <FontAwesome5 style={{ marginRight: 5 }} name="award" size={20} color={MainColors.primary} />
                                                <Text style={styles.ballotItemText}>Winner - {ballotItem.winningChoice.choiceTitle}</Text>
                                            </View>
                                        ) : (
                                                <View style={styles.ballotItemResultsContainer}>
                                                    {ballotItem.ballotItemStatus === 'Tie' ? (
                                                        <Text style={styles.ballotItemText}>
                                                            No Winner - </Text>
                                                    ) : (null)}

                                                    <Text style={styles.ballotItemText}>
                                                        {ballotItem.ballotItemStatus}</Text>

                                                    {ballotItem.ballotItemStatusReason ? (
                                                        <Text style={styles.ballotItemText}> - {ballotItem.ballotItemStatusReason}</Text>
                                                    ) : (null)}
                                                </View>
                                            )
                                        }
                                    </View>
                                ))}
                            </Card>
                        )}
                    />
                ) : (
                        <TwoLineMessage
                            firstLine='No results for any ballots yet.'
                            secondLine='Check again later!'
                            createMode={false}
                        />
                    )
                )}
            </LoadingIndicator>
        </View>
    );
}

const styles = StyleSheet.create({
    screen: {
        flex: 1,
        alignItems: 'center',
        backgroundColor: MainColors.grayBackground
    },
    resultsCard: {
        borderRadius: 8,
        ...cardShadow
    },
    cardHeaderContainer: {
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        width: '100%',
        backgroundColor: '#0074a6',
    },
    ballotTitle: {
        paddingHorizontal: 20,
        paddingVertical: 15,
        color: 'white',
        fontSize: FontSizes.large,
        fontWeight: '600',
        letterSpacing: 0.5,
        lineHeight: 24,
    },
    cardContentContainer: {
        paddingHorizontal: 20,
        paddingVertical: 15,
        borderBottomWidth: 1,
        borderBottomColor: MainColors.faintGray
    },
    ballotItemTitle: {
        color: MainColors.darkGray,
        fontSize: FontSizes.medium,
        fontWeight: '600',
        marginBottom: 10,
        letterSpacing: 0.5,
    },
    ballotItemResultsContainer: {
        flexDirection: 'row',
        alignItems: 'center',
    },
    ballotItemText: {
        color: MainColors.mediumGray,
        fontSize: FontSizes.medium,
        fontWeight: '500',
        letterSpacing: 0.5
    }
});

export default ResultsScreen;